import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { adminApi } from "../../../api-client";
import type { ReportStatus, UpdateReportStatus } from "../../../schemas/report";
import { queryKeys } from "../../query-keys";

export function useClubReports(status: ReportStatus | "all" = "open") {
	return useQuery({
		queryKey: queryKeys.reports.list(status),
		queryFn: () => adminApi.reports.list(status),
	});
}

export function useClubReportsSummary(status: ReportStatus | "all" = "open") {
	return useQuery({
		queryKey: queryKeys.reports.summary(status),
		queryFn: () => adminApi.reports.summary(status),
	});
}

export function useClubReportsByClub(clubId: string, status: ReportStatus | "all" = "all") {
	return useQuery({
		queryKey: queryKeys.reports.byClub(clubId, status),
		queryFn: () => adminApi.reports.listByClub(clubId, status),
		enabled: Boolean(clubId),
	});
}

export function useUpdateReportStatus() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, body }: { id: string; body: UpdateReportStatus }) =>
			adminApi.reports.updateStatus(id, body),
		onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.reports.all }),
	});
}

export function usePlayerReportsSummary(status: ReportStatus | "all" = "open") {
	return useQuery({
		queryKey: queryKeys.playerReports.summary(status),
		queryFn: () => adminApi.playerReports.summary(status),
	});
}

export function usePlayerReportsByPlayer(playerId: string, status: ReportStatus | "all" = "all") {
	return useQuery({
		queryKey: queryKeys.playerReports.byPlayer(playerId, status),
		queryFn: () => adminApi.playerReports.listByPlayer(playerId, status),
		enabled: Boolean(playerId),
	});
}

export function useUpdatePlayerReportStatus() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, body }: { id: string; body: UpdateReportStatus }) =>
			adminApi.playerReports.updateStatus(id, body),
		onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.playerReports.all }),
	});
}
